import $ from 'jquery';
import 'tooltipster';

const defaultOptions = {
    zIndex: 5,
    trigger: 'hover',
    contentAsHTML: true,
    interactive: true,
    contentCloning: true,
    theme: ['tooltipster-custom'],
    delay: 0,
    updateAnimation: null,
    animation: 'fade'
};

const initTooltip = ($elem, options = {}) => {
    const opts = $.extend({}, defaultOptions, options);

    if (!$elem.length) {
        return;
    }

    $elem.tooltipster(opts);
};

export default initTooltip;
